import { render, staticRenderFns } from "./FournisseursItem.vue?vue&type=template&id=f42c573a&"
import script from "./FournisseursItem.vue?vue&type=script&lang=js&"
export * from "./FournisseursItem.vue?vue&type=script&lang=js&"
import style0 from "./FournisseursItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports